import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

type Label = 'confirm-next' | 'confirm-use-photo';

@Component({
  selector: 'lv-confirm-valid-id',
  templateUrl: './confirm-valid-id.component.html',
  styleUrls: ['./confirm-valid-id.component.scss'],
  imports: [TranslateModule, FormsModule, ReactiveFormsModule]
})
export class ConfirmValidIdComponent implements OnInit {
  @Input() label: Label;
  @Output() confirmed = new EventEmitter<boolean>();

  validDocument = new FormControl(false);
  legibleDocument = new FormControl(false);

  ngOnInit() {
    this.validDocument.valueChanges.subscribe(() => this.updatePhotoConfirmed());
    this.legibleDocument.valueChanges.subscribe(() => this.updatePhotoConfirmed());
  }

  private updatePhotoConfirmed() {
    this.confirmed.emit(this.validDocument.value && this.legibleDocument.value);
  }
}
